export enum FinancialRounding {
  AsIs = 'AsIs',
  K = 'K',
  M = 'M',
}
